export const pink = {
  100: '#F977C9',
  200: '#F84FBA',
  300: '#F51AA4',
  400: '#EB0A98',
  500: '#C4087F',
}

export const green = {
  100: '#529e66',
  200: '#367b48',
  300: '#276738',
}

export const yellow = {
  100: '#e1c542',
  200: '#cab23f',
  300: '#b49e35',
}

export const red = {
  100: '#d0454c',
  200: '#b54248',
  300: '#95353a',
}

export const neutral = {
  100: '#ffffff',
  200: '#f4f5f7',
  300: '#e1e1e1',
  400: '#737581',
  500: '#4a4b53',
  600: '#000000',
}
